import React from 'react';
import { KeyboardTimePicker, KeyboardTimePickerProps, TimePicker } from '@material-ui/pickers';
import { SystemIcon, useDateTimeFormat } from '@utmost.co/utmost-design-system';
import { ReadOnly } from '../ReadOnly/ReadOnly';
import { formatDate, useSmartFormContext } from '../../forms/utils';
import { disabledAutoComplete, getAnonymousName } from '../utils/disableBrowserAutocomplete';
import { PermissionHelper } from '../common/PermissionHelper';

export const TimePickerAtom: React.FC<React.PropsWithChildren<TimePicker4Props>> = (props: any) => {
  const { getDisabled, readonly, getFieldPermissions, permissionDebugger } = useSmartFormContext();
  const { dateTimeFormat } = useDateTimeFormat();
  const permissions = getFieldPermissions(props.name);
  const isAmPm = dateTimeFormat.time === 'hh:mm a';
  const {
    keyboard,
    onChange,
    onBlur,
    onError,
    views,
    openTo,
    helperText,
    invalidDateMessage,
    name,
    value,
    error,
    label,
    ...restProps
  }: TimePicker4Props & {
    keyboard?: boolean;
    error: any;
  } = props;

  if (readonly || props.readOnly) {
    return (
      <ReadOnly
        permissionsId={props.id}
        label={props.label}
        infoText={props.infoText}
        value={formatDate(value as string | number | Date, dateTimeFormat.time ?? 'HH:mm')}
        permission={permissions}
      />
    );
  }

  const anonName = getAnonymousName(props.name);

  let { disabled } = props;

  if (getDisabled(props?.name)) {
    disabled = true;
  }

  const formHelperTextProps = {
    'data-test': `${name}-field-helper`,
    id: `${name}-helper-text`
  };

  return (
    <div>
      {keyboard ? (
        <KeyboardTimePicker
          ampm={isAmPm}
          error={error}
          helperText={helperText}
          views={views}
          openTo={openTo}
          InputLabelProps={{
            shrink: true
          }}
          InputProps={{
            ...disabledAutoComplete
          }}
          FormHelperTextProps={formHelperTextProps}
          keyboardIcon={<SystemIcon name="schedule" />}
          onBlur={onBlur}
          onChange={onChange}
          onError={props.onError || (() => {})}
          label={label ? <span data-test="info-text-label">{label}</span> : undefined}
          {...restProps}
          disabled={disabled}
          value={value}
          name={anonName}
          id={anonName}
        />
      ) : (
        <TimePicker
          ampm={isAmPm}
          error={error}
          helperText={helperText}
          views={views}
          openTo={openTo}
          InputLabelProps={{
            shrink: true
          }}
          InputProps={{
            ...disabledAutoComplete
          }}
          FormHelperTextProps={formHelperTextProps}
          onBlur={onBlur}
          onChange={onChange}
          onError={props.onError || (() => {})}
          label={label ? <span data-test="info-text-label">{label}</span> : undefined}
          {...restProps}
          disabled={disabled}
          value={value}
          name={anonName}
          id={anonName}
        />
      )}
      {permissionDebugger && <PermissionHelper permission={permissions} />}
    </div>
  );
};

export interface TimePicker4Props extends KeyboardTimePickerProps {}
